import * as React from 'react';
import { NaviContext } from './NaviContext';
export function useCurrentRoute() {
    var _a = React.useContext(NaviContext), steadyRoute = _a.steadyRoute, busyRoute = _a.busyRoute;
    return (steadyRoute || busyRoute);
}
export function CurrentRoute(props) {
    return (React.createElement(NaviContext.Consumer, null, function (context) { return props.children((context.steadyRoute || context.busyRoute)); }));
}
//# sourceMappingURL=CurrentRoute.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-navi/dist/es/CurrentRoute.js
// module id = 117
// module chunks = 0